
import Page from '@/components/FileViewer/Page.vue'
import Tabs from '@/components/UntitledUI/Tabs/Tabs.vue'
import Tab from '@/components/UntitledUI/Tabs/Tab.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import Tippy from '@/components/common/Tippy.vue'
import LockIcon from '@/components/FileViewer/Icons/LockIcon.vue'
import ChevronLeftIcon from '@/components/FileViewer/Icons/ChevronLeftIcon.vue'
import ShareIcon from '@/components/FileViewer/Icons/ShareIcon.vue'

export default {
    name: 'OtherPageLocales',
    components: {
        ShareIcon,
        ChevronLeftIcon,
        LockIcon,
        Page,
        Tabs,
        Tab,
        Icon,
        Tippy
    },
    inject: [
        'meta'
    ],
    props: {
        pages: {
            type: Array,
            default: () => []
        },
        zoomBy: {
            type: Number,
            default: 1
        },
        isText: {
            type: Boolean,
            required: true
        },
        isAllRegsOpen: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            tab: 0,
            trans: this.pages[0].locale,
            missing: []
        }
    },
    computed: {
        locales () {
            const locales = {}
            for (const locale of this.meta.locales) {
                locales[locale.code] = locale
            }
            return locales
        },
        translations () {
            const locales = []
            this.pages.forEach((page) => {
                locales.push(this.meta.locales.find(locale => locale.code === page.locale))
            })
            return locales
        },
        denied () {
            return this.pages.filter(page => page.denied).map(page => page.locale)
        },
        page () {
            return this.pages.find(page => page.locale === this.trans)
        }
    },
    watch: {
        tab () {
            this.trans = this.translations[this.tab].code
        }
    },
    created () {
        let pageIndex = 0
        for (let i = 0; i < this.pages.length; i++) {
            if (!this.pages[i].missing) {
                pageIndex = i
                break
            }
        }

        this.tab = pageIndex
    },
    mounted () {
        this.$nextTick(() => {
            this.pages.forEach((page, i) => {
                if (page.missing) {
                    this.missing.push({
                        code: page.locale,
                        ref: this.$refs.trans[i].$el
                    })
                }
            })
        })
    }
}
